module.exports = __webpack_public_path__ + "media/images/yard-overhead-a0cfb1b3.jpg";